import { render, staticRenderFns } from "./ShiftVDPLaboratoryForm.vue?vue&type=template&id=8780d446&"
import script from "./ShiftVDPLaboratoryForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPLaboratoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports